export const NAMESPACE = 'appointments';
